// LB-5154: who opens the FIX transport. OUTBOUND — the gateway dials the LP (every
// adapter so far); INBOUND — the LP connects to a cBridge FIX ingress (UNIVERSAL_FIX).
export enum ApiLpIntegrationDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
}
